import React from "react";
import "./HeroSection.css";
import heroImg from "../../Images/balcony.jpg"; // <-- replace with your image

export default function HeroSection() {
  return (
    <section
      className="renovation-hero"
      style={{ backgroundImage: `url(${heroImg})` }}
    >
      <div className="hero-overlay">
        <div className="hero-content">
          <h1 className="hero-title">Our Renovation Services</h1>
          <p className="hero-subtitle">
            Experience the pinnacle of quality and craftsmanship with our bespoke
            home renovation services, tailored to bring your vision to life.
          </p>
        </div>
      </div>
    </section>
  );
}
